const config = {
  SMA_SCHEDULER_SERVICE_BASE_URL: process.env.REACT_APP_SMA_SCHEDULER_SERVICE_BASE_URL,
  SMA_SCHEDULER_APP_URL: process.env.REACT_APP_SMA_SCHEDULER_URL,
  BEST_TOOL_URL: process.env.REACT_APP_BEST_TOOL_URL 
};

export default config;
